import React from 'react';
import {CheckCircleIcon} from '@heroicons/react/solid'
export default function ReadDocs() {
  return (
    <div style={{minHeight: '35em'}}>
      <div className="rounded-md bg-green-50 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-green-800">Congrats!</h3>
            <div className="mt-2 text-sm text-green-700">
              <p>Thank you for joining the Goracle Community!</p>
            </div>
          </div>
        </div>
      </div>
      <h3 className="text-lg leading-6 mt-5 font-medium text-gray-900">What&apos;s Next?</h3>
      <p className="mt-5  text-lg   max-w-3xl text-gray-900">
        During closed testnet, your feed is added to an alternate contract to be reviewed by the Goracle team.
        As there are no penalties and fees for joining, this step is necessary to help us better coach potential feed providers, while also allowing our future customers
        to test reading values from confirmed providers. Once your feeds are approved, they will be added to the main subscription contract manually.
      </p>
      <p className="mt-5 mb-20 text-lg   max-w-3xl text-gray-900">
       If you have any questions, feel free to reach out the Goracle team at info@Goracle.io.
      </p>

    </div>
  );
}
